import whitePurpleTip from '@assets/svgs/white-purple-tip.svg';
import ClickOutside from '@components/admin/settings/shared/ClickOutSide';
import RecentOrFavoriteDeals from '@components/shared/recentOrFavoriteDeals/RecentOrFavoriteDeals';
import { Icon } from '@components/style/Icon';
import { RecentOrFavorite } from '@enums/RecentOrFavorite';
import { theme } from '@theme';
import { FC, useState } from 'react';
import {
  DroplistHeader,
  FavoriteDealsIconWrapper,
  NavbarButton,
  NotificationDroplist,
  WhitePurpleTip,
} from './FavoriteDealsStyles';

type FavoriteDealsProps = {};

const FavoriteDeals: FC<FavoriteDealsProps> = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const toggleFavoriteDeals = () => {
    setIsVisible(!isVisible);
  };

  const outSideClick = () => {
    setIsVisible(false);
  };

  return (
    <ClickOutside className={''} onClick={outSideClick} exceptionRef={undefined}>
      <NavbarButton>
        <FavoriteDealsIconWrapper onClick={toggleFavoriteDeals} data-testid='favorite-deals'>
          <Icon
            type='favorite'
            size={theme.typography.fontSize21}
            additionalClassName='am-icon'
            color={theme.palette.white}
          />
        </FavoriteDealsIconWrapper>
        {isVisible && (
          <NotificationDroplist>
            <WhitePurpleTip>
              <img src={whitePurpleTip} />
            </WhitePurpleTip>
            <DroplistHeader>
              <h3>Favorite Deals</h3>
            </DroplistHeader>
            <RecentOrFavoriteDeals
              isVisible={isVisible}
              dealType={RecentOrFavorite.Favorite}
              dealClickedEvent={toggleFavoriteDeals}
            />
          </NotificationDroplist>
        )}
      </NavbarButton>
    </ClickOutside>
  );
};

export default FavoriteDeals;
